import { now } from "../timing";
export class FrameStats {
    constructor() {
        this.frames = 0;
        this.prevTime = 0;
        this.beginTime = 0;
        this.fps = 0;
        this.frameTime = 0;
        this.worstFrameTime = 0;
        this.bestFrameTime = Infinity;
        this.lastWorstFrameTime = 0;
        this.lastBestFrameTime = 0;
        this.nextFrame = 0;
        this.frameTimes = new Array(500);
        this.framesSampled = 0;
        this.prevTime = this.beginTime = now();
    }
    begin() {
        this.beginTime = now();
    }
    end() {
        ++this.frames;
        const time = now();
        this.frameTime = time - this.beginTime;
        this.frameTimes[this.nextFrame] = this.frameTime;
        this.framesSampled = Math.min(this.framesSampled + 1, this.frameTimes.length);
        this.nextFrame = (this.nextFrame + 1) % this.frameTimes.length;
        this.bestFrameTime = Math.min(this.frameTime, this.bestFrameTime);
        this.worstFrameTime = Math.max(this.frameTime, this.worstFrameTime);
        if (time >= this.prevTime + 1000) {
            const avg = this.frameTimes.slice(0, this.framesSampled)
                .reduce((a, b) => a + b, 0) / this.framesSampled;
            this.fps = 1000 / avg;
            this.prevTime = time;
            this.frames = 0;
            this.lastBestFrameTime = this.bestFrameTime;
            this.lastWorstFrameTime = this.worstFrameTime;
            this.bestFrameTime = Infinity;
            this.worstFrameTime = 0;
        }
    }
    getFPS() {
        return this.fps;
    }
    getUsedMemory() {
        return (performance !== undefined && performance.memory !== undefined) ? performance.memory.usedJSHeapSize / 1048576 : 0;
    }
    getFrameTime() {
        return this.frameTime;
    }
    getAvgTime() {
        if (this.framesSampled === 0)
            return 0;
        let avg = 0;
        for (let i = 0; i < this.framesSampled; ++i) {
            const idx = (i + this.nextFrame + (this.framesSampled * 2 - 1)) % this.framesSampled;
            avg += this.frameTimes[idx];
        }
        return avg / this.framesSampled;
    }
    getWorstTime() {
        return this.lastWorstFrameTime;
    }
    getBestTime() {
        return this.lastBestFrameTime;
    }
    reset() {
        this.nextFrame = 0;
        this.framesSampled = 0;
        this.worstFrameTime = 0;
        this.bestFrameTime = 0;
    }
}
